import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.v62_1 = call;
        this.w62_1 = data.w5q_1;
        this.x62_1 = data.v5q_1;
        this.y62_1 = data.y5q_1;
        this.z62_1 = data.x5q_1;
        this.a63_1 = data.a5r_1;
      }
      i5o() {
        return this.v62_1;
      }
      gw() {
        return this.i5o().gw();
      }
      j5o() {
        return this.w62_1;
      }
      k5o() {
        return this.x62_1;
      }
      a2p() {
        return this.y62_1;
      }
      v55() {
        return this.z62_1;
      }
      c5o() {
        return this.a63_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
